var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DisposalOrdersTableUser',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"reload":_vm.reload}})
}
var staticRenderFns = []

export { render, staticRenderFns }